















































































































































































import { Vue, Component } from 'vue-property-decorator'
import { IUpdateRes } from '@/api/files/files-updown/res'
import { getAndroidUpdateList, markedAppAndroid } from '@/api/files/files-updown/filesUpdown'

import { Form } from 'element-ui'
import { exportJson2Excel } from '@/utils/excel'
import { getChaos, getCookie, getImgURLOfBase64 } from '@/utils/fix'
import { formatJson, resetObjValue2NoneString, deepCopy } from '@/utils/tool'
import { getAndroidSource } from '@/api/common'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
@Component({
  name: 'FilesUpdownAndroidUpdate'
})
export default class extends mixins(DateOption) {
  // data
  private params = {
    id: '',
    name: '',
    fileBundleid: '',
    source: '',
    updateDateStart: '',
    updateDateEnd: '',
    page: 1,
    pageCount: 20
  }
  // template data
  private sourceList: Array<ISelectItem> = []

  private tableData: IUpdateRes[] = []
  private selectedData: IUpdateRes[] = []
  private totalCount: number = 0
  private dateArray: string[] = ['', '']
  routeQuery: IQuery = { id: 0, platform: 'android' }
  tableLoading = false
  openWindow: any
  tableHeight: number = 500
  // lifecycle
  created() {
    this.getTableData()
    this.getAndroidSource()
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    let res = await getAndroidUpdateList(this.params)
    let dataList = res.data.dataList || []
    let buildEnv = process.env.VUE_APP_ENV || ''
    if (buildEnv !== 'env') {
      this.tableData = dataList
      this.tableLoading = false
      this.totalCount = res.data.pageInfo.totalCount
      return false
    }
    this.tableData = []
    await getChaos()
    let header = {
      abc: getCookie('abc')
    }
    this.tableLoading = false
    const cover: string = require('@/assets/images/loading.svg')
    dataList.forEach((item: any) => {
      let el = { ...item }
      el.icon = cover
      this.tableData.push(el)
    })
    this.totalCount = res.data.pageInfo.totalCount
    for (let i = 0; i < dataList.length; i++) {
      getImgURLOfBase64(dataList[i].icon, header).then(res => {
        this.tableData[i]['icon'] = res as string
      })
    }
    this.tableLoading = false
    this.totalCount = res.data.pageInfo.totalCount
  }
  async getAndroidSource() {
    let res = await getAndroidSource()
    this.sourceList = res.data.dataList
  }
  async markedAppAndroid(ids: string) {
    let res: any = await markedAppAndroid({ ids })
    if (res.status.code === 0) {
      this['$message'].success('标记成功!')
      this.getTableData()
    } else {
      this['$message'].error('标记失败!')
    }
  }
  handleInput(val: string, attr: string) {
    (this.params as any)[attr] = val.replace(/[^0-9]/g, '')
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 260 - filterDom.clientHeight
  }
  handleDateChange(date: string[]) {
    this.params.updateDateStart = date && date[0]
    this.params.updateDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.dateArray = ['', '']
    this.params.page = 1
    this.getTableData()
  }
  handleSelectionChange(list: IUpdateRes[]) {
    this.selectedData = list
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })

    // this.selectedData = this.tableData.filter(item => indexList.includes(item.id))
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleUpdateAll() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    this.markedAppAndroid(ids)
  }
  goToDetail(item: IUpdateRes) {
    this.routeQuery.id = item.id
    this.openWindow({
      name: 'AppDetail',
      query: this.routeQuery
    })
  }
  updateApp(item: IUpdateRes) {
    let id = item.id.toString()
    this.markedAppAndroid(id)
  }
  private async handleExcel() {
    let excelParams = deepCopy(this.params)
    let res: any = await getAndroidUpdateList(Object.assign(excelParams, {
      page: 1,
      pageCount: 3000
    }))
    if (res.status.code === 0) {
      this['$message'].success('导出成功')
    } else {
      this['$message'].error('导出失败')
      return
    }
    const filterVal: string[] = [
      'id',
      'name',
      'developer',
      'category',
      'source',
      'version',
      'newVersion',
      'price',
      'score',
      'lastUpdateTime',
      'newVersionPubTime'
    ]
    const theader: string[] = [
      'ID',
      '名称',
      '开发者',
      '类别',
      '来源',
      '当前版本',
      '最新版本',
      '价格',
      '评分',
      '上次更新时间',
      '新版本发布时间'
    ]
    const list = res.data.dataList
    const data = formatJson(filterVal, list)
    exportJson2Excel(theader, data)
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
}
